// import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Stepper() {
  return {
    MuiStepConnector: {
      styleOverrides: {
        line: {
          // borderColor: '#2023b2',
          // borderColor: 'linear-gradient(180deg, #4859e9, rgba(145, 158, 171, 0.24)) 1',
        },
      },
    },

    MuiStepIcon: {
      styleOverrides: {
        root: {
          '&.Mui-completed': {
            color: '#2023b2',
            backgroundImage: 'linear-gradient(135deg, #fff, #fff)',
            borderRadius: '50%',
            boxShadow: '0 0 0 2px rgba(91, 95, 255, 0.25)',
          },
          '&.Mui-active': {
            color: 'transparent',
            backgroundImage: 'linear-gradient(135deg, #828ff2, #3945d0)',
            borderRadius: '50%',
            boxShadow: '0 0 0 2px rgba(91, 95, 255, 0.25)',
          },
          '&.Mui-disabled': {
            color: '#CBD5E1',
          },
          '& text': {
            fill: '#fff',
            fontWeight: 600,
          },
        },
      },
    },
  };
}
